function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.856 29.998c7.608-.429 13.7-6.528 14.116-14.14h-5.01a10 10 0 01-9.08 9.127l-.026 5.014zm14.116-15.806C29.556 6.572 23.45.467 15.831.05v5.011a9.999 9.999 0 019.13 9.131h5.011zM14.164.05a14.942 14.942 0 00-9.166 3.797l3.543 3.544a9.952 9.952 0 015.623-2.33V.051zM0 15.025C0 23.03 6.268 29.567 14.164 30v-5.011C9.032 24.566 5 20.267 5 15.025c0-2.46.89-4.714 2.364-6.456L3.82 5.026a14.94 14.94 0 00-3.82 10zm19.566-.281a4.86 4.86 0 00-2.588-4.298 4.86 4.86 0 01-6.571 6.571 4.86 4.86 0 009.16-2.273z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "30",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.856 29.998c7.608-.429 13.7-6.528 14.116-14.14h-5.01a10 10 0 01-9.08 9.127l-.026 5.014zm14.116-15.806C29.556 6.572 23.45.467 15.831.05v5.011a9.999 9.999 0 019.13 9.131h5.011zM14.164.05a14.942 14.942 0 00-9.166 3.797l3.543 3.544a9.952 9.952 0 015.623-2.33V.051zM0 15.025C0 23.03 6.268 29.567 14.164 30v-5.011C9.032 24.566 5 20.267 5 15.025c0-2.46.89-4.714 2.364-6.456L3.82 5.026a14.94 14.94 0 00-3.82 10zm19.566-.281a4.86 4.86 0 00-2.588-4.298 4.86 4.86 0 01-6.571 6.571 4.86 4.86 0 009.16-2.273z",
  fill: "currentColor"
}))));